import { render, staticRenderFns } from "./TeachersViewGeneral.vue?vue&type=template&id=9bec4e26"
import script from "./TeachersViewGeneral.vue?vue&type=script&lang=js"
export * from "./TeachersViewGeneral.vue?vue&type=script&lang=js"
import style0 from "./TeachersViewGeneral.vue?vue&type=style&index=0&id=9bec4e26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports